import React, { useState } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined } from '@ant-design/icons';

//ANT DESIGN IMPORTS
import {
    Row,
    Typography,
    Card,
    Form,
    DatePicker,
    Col,
    Divider,
    Button,
    Spin
} from "antd";

//PROJECT IMPORTS
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import CustomButton from '../../../../../components/custom/CustomButton';
import MainLayout from '../../../../../components/layouts/MainLayout';
import TopContent from '../../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import TextArea from 'antd/es/input/TextArea';
import { showCheckerApprovalModal } from '../../../../../components/CheckerModal';

const { Text } = Typography

const ApproveAccount = (props) => {

    const { userData } = props;
    const { session } = userData;
    const navigate = useNavigate();
    const [useForm] = Form.useForm();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);

    const disabledAfterCurrentDate = (current) => {
        return current && current.valueOf() > Date.now();
    };

    function onCancel() {
        navigate("/detail-fixed-deposit-account", { state: state });
    }

    const onSubmit = (formValues) => {
        formValues.approvedOnDate = BOM.DateTime(formValues.approvedOnDate, "only-date")

        const params = {
            command: "approve"
        }
        const url = `${apiConfig.FixedDepositAccounts}/${state.id}`

        const body = {
            ...formValues,
            locale: "en",
            method: "POST",
            dateFormat: "dd MMMM yyyy",
            locale: "en",
            session,
            params
        };

        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
                setIsLoading(false);
            } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.approveFixedDepositAccMsg);
                navigate("/detail-fixed-deposit-account", { state: state });
                //STOP LOAD
                setIsLoading(false);
            }
        },{
                navigate,
                showCheckerModal: showCheckerApprovalModal,
                onCheckerApproval: (res) => {
                  // navigate("/sms0100");
                  navigate("/detail-fixed-deposit-account", { state: state })
                  setIsLoading(false);
                },
              });
    };

    return (
        <MainLayout isEnableRightSidebar={true} >
            {/* PART 1  IMPORT TOP CONTENT*/}
            <TopContent
                pageTitle={labelConfig.approveFixedDepositAcc}
                pageItems={staticConfig.approveFixedDepositAccBreadcrumbItems}
            />

            <Spin spinning={isLoading} size="large">
                <Card
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}

                    title={
                        <Row
                            style={{
                                alignContent: "center",
                                width: "8%",
                            }}
                        >
                            <Button
                                icon={<LeftOutlined />}
                                type="text"
                                style={{
                                    marginTop: "auto",
                                    marginBottom: "auto",
                                }}
                                onClick={onCancel}
                            >
                                <Text
                                    style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                                >
                                    Back
                                </Text>
                            </Button>
                        </Row>
                    }
                >
                    <Form
                        form={useForm}
                        layout="vertical"
                        onFinish={onSubmit}
                    >

                        <Row >
                            <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.approvedOn}
                                    name="approvedOnDate"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(
                                                labelConfig.approvedOn
                                            ),
                                        },
                                    ]}
                                >
                                    <DatePicker
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.approvedOn}`,
                                            "select"
                                        )}
                                        style={{ width: '100%' }}
                                        disabledDate={disabledAfterCurrentDate}
                                    />
                                </Form.Item>
                            </Col>

                            <Divider orientation="left" orientationMargin="0"></Divider>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.note}
                                    name="note"
                                >
                                    <TextArea style={{ width: "45vh", height: "15vh" }} placeholder='Please enter a note' />

                                </Form.Item>
                            </Col>
                        </Row>

                        <Row>
                            <Divider />
                            <CustomButton
                                content="Submit"
                                style={{
                                    width: "10%",
                                    marginLeft: "auto",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                htmlType="submit"
                                backgroundColor="#15CCAE"
                                colorText="black"
                                hoverBackground="#4FECA0"
                            />

                            <CustomButton
                                content="Cancel"
                                style={{
                                    width: "10%",
                                    marginLeft: "1%",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                backgroundColor="#fff"
                                colorText="black"
                                hoverBackground="#F5F5F5"
                                onClick={onCancel}
                            />
                        </Row>
                    </Form>
                </Card>
            </Spin>

        </MainLayout>
    )
}

export default ApproveAccount